import axios from '../shared/axios';

export function getPDF(fileid){
    
    return axios.get(`/api/PDF/GetPDF?fileid?fileid=${fileid}`)
}


export function regeneratePDF(payload) {
    return axios.post(`/api/PDF/RegeneratePDF`, payload, { responseType: 'blob'});
}